<template>
  <div class="com-detail">
    <div class="title-default">
      <i class="goback" @click="$router.go(-1)">{{
        detaliInfo.name.split("/")[0]
      }}</i>
      /
      <span>{{ detaliInfo.name.split("/")[1] }}</span>
    </div>
    <div class="detail-content">
      <div class="top-title">{{ comDetail.title }}</div>
      <div class="detail-time">
        {{ new Date(comDetail.createTime).format("yyyy-MM-dd HH:mm:ss") }}
      </div>
      <div class="bottom-content" v-html="comDetail.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detaliInfo: {
        name: "消息通知/消息详情"
      },
      comDetail: {
        title: ""
      }
    };
  },
  created() {
    this.comDetail = this.$route.params;
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.com-detail {
  background: #ffffff;
  & /deep/ .title-default {
    height: auto;
  }
  .detail-content {
    padding: 6px 20px 30px 20px;
    .top-title {
      width: 776px;
      font-weight: bold;
      color: rgba(47, 49, 51, 1);
      line-height: 30px;
      font-size: 20px;
    }
    .detail-time {
      margin-top: 16px;
      color: #909399;
      font-size: 12px;
      height: 12px;
      line-height: 1;
    }
    .bottom-content {
      margin-top: 24px;
      font-size: 12px;
      color: #5e6066;
      line-height: 20px;
      &/deep/img {
        float: unset !important;
      }
    }
  }
}
</style>
